import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'

import {BlogCategoryTable} from './BlogCategoryTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {BlogCategoryEditModal} from './blog-category-add-edit/BlogCategoryEditModal'

const BlogCategoryList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <BlogCategoryTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <BlogCategoryEditModal />}
    </>
  )
}

const BlogCategoryListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <BlogCategoryList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {BlogCategoryListWrapper}
